import SponsorInfo from "../../../../components/SponsorInfo/component";

const SponsoredWidgetContainer = ({ params }) => {
    // null case is handled within <SponsorInfo/>
    return <SponsorInfo sponsorContent={params} />;
};

export default SponsoredWidgetContainer;
